import { ICountryGroup, ICountryGroupData } from './types';

export const normalizeCountryGroup = (data: ICountryGroup): ICountryGroupData => {
  return {
    countRulesetsUse: data?.countRulesetsUse as number,
    countryCodes: data?.countryCodes || [],
    groupType: (data?.groupType as string) || '',
    id: (data?.id as number) || 0,
    merchantId: (data?.merchantId as number) || 0,
    merchantName: (data?.merchantName as string) || '',
    merchantTerminalId: (data?.merchantTerminalId as number) || 0,
    merchantTerminalName: (data?.merchantTerminalName as string) || '',
    name: (data?.name as string) || '',
  };
};
